import { render, staticRenderFns } from "./FormPessoa.vue?vue&type=template&id=15c82d6a"
import script from "./FormPessoa.vue?vue&type=script&lang=js"
export * from "./FormPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports